import React from 'react';
import classNames from 'classnames';

import styles from './styles.css';

/**
 * Typing indicator component
 * @returns {Object}
 */
function TypingIndicator() {
  return (
    <div className={classNames('ciscospark-typing-background', styles.background)}>
      <div className={classNames('ciscospark-typing-indicator', styles.typingIndicator)}>
        <div className={classNames('ciscospark-sq', styles.sq)} />
        <div className={classNames('ciscospark-sq', styles.sq)} />
        <div className={classNames('ciscospark-sq', styles.sq)} />
      </div>
    </div>
  );
}

export default TypingIndicator;
